import React, { useEffect } from "react";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useShallow } from "zustand/react/shallow";

import { useOrderManager } from "~/managers/use-order-manager";
import { useCartStore } from "~/stores/use-cart-store";
import { useOrderStore } from "~/stores/use-order-store";
import { Button } from "../ui/button";
import { Checkbox } from "../ui/checkbox";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import OrderTransferForm from "./order-transfer-form";

export default function OrderTransferDialog() {
  const { startTransfer } = useOrderManager();

  const {
    transferDialogOpen,
    setTransferDialogOpen,
    setTransferItems,
    transferItems,
  } = useOrderStore(
    useShallow((state) => ({
      transferDialogOpen: state.transferDialogOpen,
      setTransferDialogOpen: state.setTransferDialogOpen,
      transferItems: state.transferItems,
      setTransferItems: state.setTransferItems,
    })),
  );

  const { items } = useCartStore(
    useShallow((state) => ({
      items: state.items,
    })),
  );

  const handleDialog = (open: boolean) => {
    if (open === false) {
      setTransferDialogOpen(false);
    } else {
      setTransferItems([]);
    }
    setTransferDialogOpen(open);
  };

  useEffect(() => {
    if (transferDialogOpen === true) {
      setTransferItems([]);
    }
  }, [setTransferItems, transferDialogOpen]);

  return (
    <Dialog open={transferDialogOpen} onOpenChange={handleDialog}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Transfer items</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <ScrollArea className="max-h-[80vh] p-0">
          <div className="flex items-center gap-4 p-2 justify-between border-b">
            <Checkbox
              id="terms"
              onCheckedChange={(checked) => {
                if (checked === true) {
                  setTransferItems(items);
                } else {
                  setTransferItems([]);
                }
              }}
            />
            <label
              htmlFor="terms"
              className="text-md flex-1  font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Select all
            </label>
          </div>
          <OrderTransferForm />
        </ScrollArea>
        <DialogFooter>
          <Button
            disabled={transferItems.length === 0}
            onClick={() => {
              startTransfer();
              handleDialog(false);
            }}
            className="w-full"
          >
            {transferItems.length > 0 ? "Transfer items" : "Transfer order"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
